import React from 'react';
import { useIntl } from 'react-intl';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: "500px",
        width: "100%",
        padding: "50px",
        fontSize: "20px"
    },
};

type Props = {
    isOpen: boolean,
    onRequestClose: () => void
}

export const TimeoutWarningModal: React.FC<Props> = ({ isOpen, onRequestClose }) => {
    const intl = useIntl()
    const onLogOffCall = () => {
        // Implement your logout functionality here, e.g. clear the users login cache or hit your signout server
        window.location.href = "/logout"
    }

    return (
        <div>
            <Modal
                isOpen={isOpen}
                style={customStyles}
            >
                <h2>{intl.formatMessage({ id: 'SESSIONTIMEOUT.HEADER' })}</h2>
                <div>{intl.formatMessage({ id: 'SESSIONTIMEOUT.CONTENT' })}</div>
                <br />
                <div className='class="text-center'>
                    <button className='btn btn-sm btn-danger me-3 mb-5' onClick={onLogOffCall}>{intl.formatMessage({ id: 'MENU.LOGOUT' })}</button>
                    <button className='btn btn-sm btn-primary mb-5' onClick={onRequestClose}>{intl.formatMessage({ id: 'MENU.STAYONLINE' })}</button>
                </div>
            </Modal>
        </div>
    );
}